module.exports = __webpack_public_path__ + "static/media/close-Icon.dfb9c00c.svg";